import React from 'react';
import { Box, Select } from '@attain-sre/attain-design-system';
import { Chip, MenuItem } from '@material-ui/core';

interface Option {
  id: string;
  label: string;
}

interface MultiSelectProps {
  options: Option[];
  value: string[];
  onChange: (value: string[]) => void;
  placeholder: string;
  tagLimit?: number;
  disabled?: boolean;
}

const MultiSelect: React.FC<MultiSelectProps> = ({
  options,
  value,
  onChange,
  placeholder,
  tagLimit = 2,
  disabled = false,
}) => {
  const handleSelectChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const selected = event.target.value as string[];
    onChange(selected);
  };

  return (
    <Select
      disabled={disabled}
      multiple
      displayEmpty
      value={value}
      onChange={handleSelectChange}
      style={{ width: '100%', height: 46 }}
      renderValue={selected => {
        if (!selected.length) return <span>{placeholder}</span>;

        const selectedList = options.filter(opt =>
          (selected as string[]).includes(opt.id)
        );
        const visible = selectedList.slice(0, tagLimit);
        const hidden = selectedList.length - tagLimit;

        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'nowrap',
              overflowX: 'hidden',
            }}
          >
            {visible.map(option => (
              <Chip
                key={option.id}
                label={option.label}
                sx={{
                  height: 32,
                  '& .MuiChip-label': {
                    paddingRight: '30px',
                  },
                  '& .MuiChip-deleteIcon': {
                    marginRight: '-10px',
                  },
                }}
              />
            ))}
            {hidden > 0 && ` +${hidden}`}
          </Box>
        );
      }}
      fullWidth
      MenuProps={{
        PaperProps: {
          sx: {
            maxHeight: 200,
          },
        },
      }}
    >
      {options.map(option => (
        <MenuItem
          key={option.id}
          value={option.id}
          sx={{
            fontSize: '14px',
            padding: 5,
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.08)',
            },
          }}
        >
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default MultiSelect;
